import React from 'react'
import PropTypes from 'prop-types'
import { Box } from 'pcln-design-system'
import styled from 'styled-components'

const StyledBox = styled(Box)`
  position: ${props => props.isMobile ? '' : 'absolute'};
  margin-top: ${props => props.isMobile ? '12px' : '0px'};
  top: ${props => props.isMobile ? '' : '68px'};
  left: ${props => props.isMobile ? '' : '10px'};
`

const FreeCancellationCopy = ({ isMobile = false, children }) => {
  return (
    <StyledBox isMobile={isMobile} id='cancellation-box'>
      {children}
    </StyledBox>
  )
}

FreeCancellationCopy.propTypes = {
  isMobile: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired
}

export default FreeCancellationCopy
